import React from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import PersonOffIcon from "@mui/icons-material/PersonOff";

export const OkIcon = () => <CheckCircleIcon sx={{ color: "#2C9E4B" }} />;
export const ErrorIcon = () => <HighlightOffIcon sx={{ color: "#DA1113" }} />;
export const DemoIcon = () => <RemoveCircleOutlineIcon sx={{ color: "#FFA500" }} />;
export const UserCancelIcon = () => <PersonOffIcon sx={{ color: "#FFA500" }} />;
export const NotExecutedIcon = () => (
  <RemoveCircleOutlineIcon sx={{ color: "#9CA3AF" }} />
);
